var _g, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNoResults = function SvgNoResults(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 171,
    viewBox: "0 0 258 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.224,
    cy: 45.836,
    r: 22.888,
    fill: "#E2E8F0",
    stroke: "#E2E8F0",
    strokeWidth: 8.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.532 108.963a27.705 27.705 0 0 1-38.305 25.595A27.706 27.706 0 0 1 .125 108.963h55.407Z",
    fill: "#FF5454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.059 75.326c0 7.084-5.866 12.93-13.23 12.93-7.365 0-13.231-5.846-13.231-12.93s5.866-12.93 13.23-12.93c7.365 0 13.231 5.846 13.231 12.93Z",
    stroke: "#F6F8FC",
    strokeWidth: 6.615
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2230",
    d: "M13.955 72.076 27.29 85.412 13.955 98.747.619 85.412z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.195 112.93a5.295 5.295 0 0 1 2.751 1.287",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.683 169.049a2.643 2.643 0 1 0-1.93-4.921 2.643 2.643 0 0 0 1.93 4.921Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m131.228 78.811-1.134 1.6a4.005 4.005 0 0 0 .95 5.585l23.439 16.624a4.006 4.006 0 0 0 5.585-.95l1.135-1.6a4.006 4.006 0 0 0-.95-5.585l-23.44-16.624a4.006 4.006 0 0 0-5.585.95Z",
    fill: "#FF5454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m148.617 95.134 2.441-3.413a6.86 6.86 0 0 1 9.501-1.637l25.93 17.008a8.762 8.762 0 0 1 2.072 12.214l-.185.208a8.744 8.744 0 0 1-9.095 3.471 8.746 8.746 0 0 1-3.119-1.4l-25.92-16.999a6.845 6.845 0 0 1-1.631-9.55l.006.098Z",
    fill: "#1B2230",
    stroke: "#1B2230",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.569 34.34a41.213 41.213 0 1 0 57.458-9.772 41.228 41.228 0 0 0-57.459 9.772Zm60.59 42.97a33.063 33.063 0 0 1-50.986 3.61 33.062 33.062 0 1 1 50.986-3.61Z",
    fill: "#1B2230"
  })));
};
export default SvgNoResults;